import React from 'react';
import { Grid } from '@mui/material';

import SubUserRegisterContainer from '../containers/subuser/SubUserRegisterContainer';
import SubUserStatusContainer from '../containers/subuser/SubUserStatusContainer';
import NewPage from '../components/NewPage';

const SubUserPage = () => {
  return (
    <NewPage title="사용자 등록•관리">
      <Grid item xs={12}>
        <SubUserRegisterContainer />
      </Grid>
      <Grid item xs={12}>
        <SubUserStatusContainer />
      </Grid>
    </NewPage>
  );
};

export default SubUserPage;
